import React from "react";
import breadcumbBg from "../assets/img/breadcrumb/01.jpg";
import Breadcumb from "../components/Breadcumb";
import AboutArea from "../components/About/AboutArea";

const About = () => {
  return (
    <div>
      <main class="main">
        <Breadcumb pageTitle="About Us" backgroundImage={breadcumbBg} />
        <AboutArea />
      </main>
    </div>
  );
};

export default About;
